module.exports = __webpack_public_path__ + "media/images/flowers-fc5d662c97729dbf62e8408e9af8abfa.jpg";